import { createAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store/store";
import { logoutUser } from "./common";

const initialState = {
  value: ""
};

export const ipSlice = createSlice({
  name: "ip",
  initialState,
  reducers: {
    updateIP: (state,action) => {
      state.value =action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(logoutUser, () => {
        return initialState;
      })
  },
});

export const { updateIP } = ipSlice.actions;
export const getIp = (state:RootState) => state.ip.value;
export default ipSlice.reducer;